export default class Base {

  fadeIn() {
    $("#overlay").fadeIn(300)
  }

  fadeOut() {
    $("#overlay").fadeOut(300)
  }

  ajax(params) {
    $.ajax({
      url: params.url,
      type: params.type,
      cache: false,
      data: params.data,
    })
      .done( (data) => {
        params.callback(data)
      })
      .fail( (jqXHR, textStatus, errorThrown) => {
        alert('通信エラー')
      })
      .always( (data) => {
      })
  }

}
